import { Persona } from "../domain/entities/persona";
//import { Prestacion } from "../domain/entities/prestacion";
import { ProtocoloService } from "../domain/services/protocoloService";

export class GetPersona {
  constructor(private protocoloService: ProtocoloService) {}

  async execute(token: string): Promise<Persona> {
    const colPrestaciones: Persona = await this.protocoloService.getPersona(
      token
    );
    return colPrestaciones;
  }
}
